// web/src/player/emotion.ts
import type { Emotion } from "./types";

export const EMOTION = {
  SURPRISE_DURATION_MS: 1500,
  TALKING_HOLD_MS: 1000,
  TALKING_DELTA: 1.5,
} as const;

export class EmotionEngine {
  private censorTriggerTime = -1;
  private lastTalkingTime = -Infinity;

  update(time: number, opts: { zoomActive: boolean; isCensored: boolean; mouth: number; closed: number }): Emotion {
    let e: Emotion = "Idle";
    if (opts.zoomActive) { this.censorTriggerTime = -1; e = "Point"; }

    if (opts.isCensored && !opts.zoomActive && this.censorTriggerTime === -1) this.censorTriggerTime = time;
    if (this.censorTriggerTime !== -1) {
      if (time - this.censorTriggerTime < EMOTION.SURPRISE_DURATION_MS / 1000) {
        if (e !== "Point") e = "Surprised";
      } else this.censorTriggerTime = -1;
    }
    if (e === "Idle") {
      if (Math.abs(opts.mouth - opts.closed) > EMOTION.TALKING_DELTA) { this.lastTalkingTime = time; e = "Talking"; }
      else if (time - this.lastTalkingTime < EMOTION.TALKING_HOLD_MS / 1000) e = "Talking";
    }
    return e;
  }
  reset() { this.censorTriggerTime = -1; this.lastTalkingTime = -Infinity; }
}
